<template>
    <div class="list">
        <div class="radio">
            <el-radio-group v-model="radioGroup">
                <el-radio style="display:block;" :label="item" :key="item.id" v-for="item in childData"><i class="el-icon-document"></i>{{ item.fileName }}</el-radio>
            </el-radio-group>
        </div>
        <div slot="footer" class="dialog-footer partFooter">
            <el-button type="danger" @click="check" v-permission="'80'">查看文件</el-button>
            <el-button type="primary" @click="download" v-permission="'81'">下载文件</el-button>
            <el-button type="primary" class="updatekc" v-permission="'82'">替换文件 <input class="filebox" type="file" name="file" ref="imgFile" id='downFile' v-on:change="handleFileChange"></el-button>
        </div>
    </div>
</template>

<script>
import permission from '../../directives/permission/index'

export default {
    directives: {
        permission
    },
    props: ['childData'],
    data() {
        return {
            radioGroup: {},
            loadOption: [],
        }
    },
    mounted() {
    },
    methods: {
        check() {
            this.$emit('toparent', this.radioGroup)
        },
        download() {
            if (this.radioGroup.fileUrl) {
                var suffix = this.radioGroup.fileName.substring(this.radioGroup.fileName.lastIndexOf(".") + 1);
                console.log(suffix);
                if (suffix == 'pdf') {
                    let exportUrl = axios.defaults.baseURL;
                    var formData = new FormData();
                    formData.append("fileName", this.radioGroup.fileName)
                    formData.append("id", this.radioGroup.id)
                    formData.append("clientName", this.radioGroup.clientName)
                    axios
                        .post(
                            exportUrl + "register/findElectronicCaseById", formData, {
                                responseType: "blob",
                            }
                        )
                        .then((res) => {
                            const blob = new Blob([res.data], );
                            // // console.log(blob, '----------0990');
                            const fileName = this.radioGroup.fileName;
                            const linkNode = document.createElement("a");
                            linkNode.download = fileName; //a标签的download属性规定下载文件的名称
                            linkNode.style.display = "none";
                            let URL = window.URL || window.webkitURL;
                            linkNode.href = window.URL.createObjectURL(blob); //生成一个Blob URL
                            document.body.appendChild(linkNode);
                            linkNode.click(); //模拟在按钮上的一次鼠标单击
                            URL.revokeObjectURL(linkNode.href); // 释放URL 对象
                            document.body.removeChild(linkNode);
                        });
                } else {
                    window.open(this.radioGroup.fileUrl);
                }

            } else if (!this.radioGroup.fileUrl) {
                _g.toast("warning", '请选择要下载的文件!!!');
                return;
            }
        },
        handleFileChange() {
            if (!this.radioGroup.id || this.radioGroup.id == '') {
                _g.toast("warning", '请选择要替换的文件!!!');
                return;
            }
            var file = document.getElementById("downFile").files[0]; //获取文件
            var formData = new FormData();
            formData.append("file", file)
            formData.append("id", this.radioGroup.id)
            api.requestQuiet("/register/updateElectronicCase", formData, (res) => {
                if (res.result == true) {
                    _g.toast("success", '文件修改成功');
                    this.$emit("close1");
                    this.$emit("add-comment");
                    var test = document.getElementById('downFile');
                    test.value = '';
                } else {
                    _g.toast("error", res.errMsg);
                }
            }, (err) => { });
        },
    },
}
</script>
<style scoped>
.radio {
  display: flex;
  justify-content: center;
}
.radio >>> .el-radio__label {
  font-size: 16px;
  font-weight: 500;
}
.radio >>> .el-radio {
  margin-bottom: 15px;
}
.pdfPriview {
  height: 100%;
  overflow: hidden;
}
.filebox {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 1;
  left: 0;
  top: 0;
}
.updatekc {
  position: relative;
  cursor: pointer;
}
</style>


